import type { CSSProperties, MouseEvent, ReactNode } from 'react';

import useColor from '@/hooks/domain/useColor';
import { animation } from '@/styles/style';
import zIndex from '@/styles/zIndex';

import { DropdownBackground } from '../base';
import Transition from '../Common/Transition';
import Portal from '../Portal/Portal';

type Props = {
  close?: (e: MouseEvent) => void;
  onBgRightClick?: (e: MouseEvent) => void;
  status: boolean;
  children: ReactNode;
  style?: CSSProperties;
  bgStyle?: CSSProperties;
};

const SelectPortal = (props: Props) => {
  const color = useColor();
  return (
    <Portal id="dropdown-layer">
      {props.status && (
        <DropdownBackground
          onClick={(e) => {
            e.stopPropagation();
            props.close?.(e);
          }}
          onContextMenu={(e) => {
            e.stopPropagation();
            e.preventDefault();
            props.onBgRightClick?.(e);
          }}
          style={props.bgStyle}
        />
      )}
      <Transition
        status={props.status}
        style={{
          zIndex: zIndex.dropdown,
          position: 'fixed',
          border: `1px solid ${color.gray300}`,
          boxShadow: `0px 2px 16px ${color.FD08}`,
          backgroundColor: color.gray100,
          backdropFilter: 'blur(12px)',
          borderRadius: 10,
          ...props.style,
        }}
        animations={{
          in: animation.dropdownIn,
          out: animation.dropdownOut,
        }}
        duration={120}
      >
        {props.children}
      </Transition>
    </Portal>
  );
};

export default SelectPortal;
